module.exports = __webpack_public_path__ + "blacklightbulb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacklightbulb.png
// module id = 857
// module chunks = 0